// src/pages/dashboard/section-boomspray/SectionBoomSpray.jsx
import React from "react";
import { Paper, Stack, Typography, Box, Grid } from "@mui/material";
import ShowerOutlinedIcon from '@mui/icons-material/ShowerOutlined';
import SummaryBoom from "../../boom-sprayer/summary-boom/SummaryBoom";

function SectionLabita({ paperShadow }) {
    return (
        <Paper
            sx={{
                p: 3,
                mb: 3,
                borderRadius: 2,
                boxShadow: paperShadow,
            }}
        >
                <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
                    <ShowerOutlinedIcon sx={{ fontSize: 32, color:"#2196F3" }} />
                    <Box>
                        <Typography variant="h6" fontWeight="bold">
                            Boom Spray
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Deskripsi
                        </Typography>
                    </Box>
                </Stack>
                <Typography variant="body1" color="text.primary">
                    <Grid container spacing={12}>
                    <Grid size={12}>
                        <SummaryBoom/>
                    </Grid>
                </Grid>
                </Typography>
        </Paper>
    );
}

export default SectionLabita;